// Libs
import React from "react";
import { useNavigate } from "react-router-dom";
import useLocalStorage from "use-local-storage";

// Assets
import logo from "../../assets/logo.png"

// Style
import style from "./style.module.css";

const Header = ({ webText, toggleTheme, toggleWebLanguage, webLanguage = "sk", webTheme = "light", showAuthBtn = true, backButton = false, logMeOut}) => {

    const navigate = useNavigate();

    const [authenticated, setAuthenticated] = useLocalStorage("authenticated", localStorage.authenticated);
    const [dropDownMenuOpened, setDropDownMenuOpened] = React.useState(false);

    return (
        <header className={style.headerBox}>

          {backButton ?
            <svg className={style.backButton} onClick={() => navigate("/")} viewBox="0 0 512 512">
              <path d="M205 34.8c11.5 5.1 19 16.6 19 29.2l0 64 112 0c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96l-96 0 0 64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"/>
            </svg>
            :
            <p className={`${style.backButton} empty`}>.</p>
          }

          <p className={style.number1}>0949144888</p>

          <div className={style.logo} onClick={() => navigate("/")}>
            <img src={logo} alt="Brajo" />
            <p>BRAJO, s.r.o.</p>
          </div>

          <p className={style.number2}>0905664628</p>

          <div className={style.dropDownMenu} onClick={() => setDropDownMenuOpened(prevStatus => !prevStatus)}>
            <svg viewBox="0 0 448 512" className={style.hamburger}>
              <path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/>
            </svg>
            <div id={dropDownMenuOpened ? style.dropDownActive : ""} authenticated={authenticated.toString()} className={style.dropDown}>
              {authenticated && <button onClick={() => navigate("/inbox")}>Správy</button> }
              <button onClick={toggleTheme}>Zmena témy</button>
              {authenticated ?
                <button onClick={logMeOut} className={style.authButton}>{webText.logoutButton}</button>
                :
                <button onClick={() => navigate("/login")} className={style.authButton}>{webText.loginButton}</button>
              }
            </div>
          </div>

        </header>
    );
};

export default Header;